module.exports = __webpack_public_path__ + "img/the surface is so fun.15bed589.png";